import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Field, Input, Textarea, Btn, Toggle } from "@/components/admin/AdminUI";
import ImageUpload from "@/components/admin/ImageUpload";

const EMPTY = { title: "", subtitle: "", button_text: "", button_url: "", video_url: "", fallback_image: "", active: true };

export default function HeroAdmin() {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/hero").then((r) => { if (r.data) setForm({ ...EMPTY, ...r.data }); }); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      const payload = { ...form }; delete payload.key;
      await api.put("/admin/hero", payload);
      toast.success("Hero actualizado");
    } catch { toast.error("Error al guardar"); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl">
      <header className="mb-8">
        <h1 className="font-serif text-4xl tracking-tight">Configuración del Hero</h1>
        <p className="text-sunset-muted text-sm mt-1">Personaliza la portada de video de la página principal.</p>
      </header>

      <div className="bg-white border border-sunset-border p-8">
        <div className="mb-6"><ImageUpload label="Video de fondo (MP4)" value={form.video_url} onChange={(v) => set("video_url", v)} accept="video/mp4,video/webm" /></div>
        <div className="mb-6"><ImageUpload label="Imagen de respaldo (fallback)" value={form.fallback_image} onChange={(v) => set("fallback_image", v)} /></div>
        <Field label="Título"><Input data-testid="hero-title" value={form.title} onChange={(e) => set("title", e.target.value)} /></Field>
        <Field label="Subtítulo"><Textarea rows={2} value={form.subtitle} onChange={(e) => set("subtitle", e.target.value)} /></Field>
        <div className="grid grid-cols-2 gap-4">
          <Field label="Texto del botón"><Input value={form.button_text} onChange={(e) => set("button_text", e.target.value)} /></Field>
          <Field label="URL del botón"><Input value={form.button_url} onChange={(e) => set("button_url", e.target.value)} placeholder="/articulos" /></Field>
        </div>
        <div className="py-2 mb-6"><Toggle checked={form.active} onChange={(v) => set("active", v)} label="Hero activo" /></div>
        <Btn variant="accent" onClick={save} disabled={saving} data-testid="save-hero-btn">{saving ? "Guardando…" : "Guardar cambios"}</Btn>
      </div>
    </div>
  );
}
